import React from "react";
import * as Sentry from "@sentry/react";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router";

const tracesSampleRate = import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE
  ? parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE)
  : 1.0;

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  // Send default PII (e.g., IP address)
  sendDefaultPii: true,
  // Performance tracing
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracesSampleRate,
  // Environment and release for better grouping/sourcemaps
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
  release: import.meta.env.VITE_SENTRY_RELEASE,
});

export default Sentry;

